module.exports = __webpack_public_path__ + "img/img02.677f7537.jpeg";